import React from "react";
import { useLang } from "../../context/lang-context";

const LandingFooter: React.FC = () => {
  const { t } = useLang();

  return (
    <footer className="landing-footer">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 text-center text-md-start mb-4 mb-md-0">
            <img src="/img/logo_svg.svg" alt="Foo" className="footer-logo" />
            <p className="footer-tagline">
              {t("Pide comida en línea", "Order food online")}
            </p>
          </div>
          <div className="col-6 col-md-3 mb-4 mb-md-0">
            <h5>{t("Descargar", "Download")}</h5>
            <ul>
              <li>
                <a
                  href="https://apps.apple.com/us/app/foo-app/id1434604093"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  App Store (iOS)
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.fooappmx.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Play (Android)
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-3">
            <h5>{t("Empresa", "Company")}</h5>
            <ul>
              <li>
                <a
                  href="https://partner.fooapp.mx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("Foo para Empresas", "Foo for Business")}
                </a>
              </li>
              <li>
                <a href="/contact">
                  {t("Contacto", "Contact")}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <p className="text-center footer-copy">
          &copy; {new Date().getFullYear()} Foo.{" "}
          {t("Todos los derechos reservados.", "All rights reserved.")}
        </p>
      </div>
    </footer>
  );
};

export default LandingFooter;
